import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef
} from '@angular/material/dialog';
import { UsersService } from '../../users-service/users.service';
import { GrpcStatusEvent } from '@ngx-grpc/common';
import {
    UserGroupDto,
    DisableGroupStatusRequest
} from '../../../../protos/generated/admin.pb';

@Component({
    selector: 'app-confirm-dialog',
    imports: [MatButtonModule, MatDialogModule],
    templateUrl: './confirm-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: UserGroupDto,
        private usersService: UsersService,
        public dialogRef: MatDialogRef<ConfirmDialogComponent>
    ) {}
    toggleUserGroup() {
        const request = new DisableGroupStatusRequest();
        request.id = this.data.id;
        request.status = !this.data.disabled;
        this.usersService.changeUserGroupDisableStatus(request).subscribe({
            next: () => {
                this.usersService.notifyUserGroupChanged();
                this.dialogRef.close(true);
            },
            error: (err: GrpcStatusEvent) => {
                console.error(err.statusMessage);
            }
        });
    }
}
